import { useEffect } from "react";

const LIVE_CHAT_SCRIPT_ID = "livechat-tracking-script";

/**
 * 功能：根据环境变量动态加载 LiveChat 小部件，避免把站点 License 直接写死在代码中。
 */
function LiveChatWidget() {
  useEffect(() => {
    const license = process.env.REACT_APP_LIVECHAT_LICENSE?.trim();

    if (!license || typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    if (document.getElementById(LIVE_CHAT_SCRIPT_ID)) {
      return;
    }

    const parsedLicense = Number(license);

    window.__lc = window.__lc || {};
    window.__lc.license = Number.isNaN(parsedLicense) ? license : parsedLicense;
    window.__lc.integration_name = "manual_channels";
    window.__lc.product_name = "livechat";

    if (!window.LiveChatWidget) {
      const widget = {
        _q: [],
        _h: null,
        _v: "2.0",
      };

      const queueAction = (payload) => {
        if (widget._h) {
          return widget._h.apply(null, payload);
        }

        widget._q.push(payload);
        return undefined;
      };

      widget.on = (...args) => queueAction(["on", args]);
      widget.once = (...args) => queueAction(["once", args]);
      widget.off = (...args) => queueAction(["off", args]);
      widget.call = (...args) => queueAction(["call", args]);
      widget.get = (...args) => {
        if (!widget._h) {
          throw new Error("[LiveChatWidget] You can't use getters before load.");
        }

        return queueAction(["get", args]);
      };

      window.LiveChatWidget = widget;
    }

    const script = document.createElement("script");
    script.id = LIVE_CHAT_SCRIPT_ID;
    script.async = true;
    script.src = "https://cdn.livechatinc.com/tracking.js";
    document.head.appendChild(script);
  }, []);

  return null;
}

export default LiveChatWidget;
